// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const cvvMask = (value: string) => {
    const newValue = value.replace(/\D/g, "");
    return newValue;
};
